import React from 'react'
import { Paragraph, H4, Field as _Field } from './__styles__'


export default function Field({ title = '', value = '' }) {
    return (
        <_Field>
            <H4>{title}</H4>
            <Paragraph>{value}</Paragraph>
        </_Field>
    )
}
